export const ACCESS_COOKIE = 'access-token';
export const REFRESH_COOKIE = 'refresh-token';
